import { ThrowStmt } from "@angular/compiler";
import { ChangeDetectorRef, Component, Input, OnInit, Output, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import * as moment from "moment";
import { Observable, Subscription } from "rxjs";
import { DetalleDte } from "src/app/models/Dte/DetalleDte";
import { TotalDteEmitido } from "src/app/models/Dte/TotalDteEmitido";
import { FacturacionIndividualService } from "src/app/services/facturacion-individual.service";
import { environment } from "src/environments/environment";
import { EventEmitter } from "@angular/core";
import { TipoDte } from "src/app/models/tipoDte";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { FormaPago } from "src/app/models/Dte/FormaPago.enum";
import { OtraMoneda } from "src/app/models/Dte/OtraMoneda";
import { OptionsReferenceDteEmitido } from "src/app/models/Dte/OptionsReferenceDteEmitido";
import { Divisa } from "src/app/models/Divisa";
import { PositiveNumberValidator } from "src/app/directives/positive-number.directive";
import { NonNegativeNumberValidator } from "src/app/directives/non-negative.directive";
import { DescuentoRecargo } from "src/app/models/Dte/DescuentoRecargo";
import { TipoMovimiento } from "src/app/models/Dte/TipoMovimiento.enum";
import { ExpresionDinero } from "src/app/models/Dte/ExpresionDinero.enum";
import { IndicadorExento } from "src/app/models/Dte/IndicadorExento.enum";
import { InvoiceType } from "src/app/models/Dte/invoiceType.enum";
import { Producto } from "src/app/models/Producto/Producto";
import { TipoTraslado } from "src/app/models/TipoTraslado";
import { ComisionRecargo } from "src/app/models/Dte/ComisionRecargo";
import { ModalidadVentas } from "src/app/models/Dte/Exportacion/ModalidadVentas";
import { ClausulaVentas } from "src/app/models/Dte/Exportacion/ClausulaVentas";
import { ExportacionTransporteDte } from "src/app/models/Dte/exportacionDte";
import { threadId } from "worker_threads";
import { runInThisContext } from "vm";
import { TipoDespacho } from "src/app/models/TipoDespacho";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import { ignoreElements } from "rxjs/operators";
import { UtilitiesService } from "src/app/services/utilities.service";
import { ThrottlingUtils } from "@azure/msal-common";
import { DetalleDteImpuestoAdicional } from "src/app/models/Dte/DetalleDteImpuestoAdicional";
import { ItemDetalleComisionComponent } from "../item-detalle-comision/item-detalle-comision.component";
import { CurrencyPipe } from "@angular/common";
import { FormatoDte } from "src/app/models/Dte/FormatoDte";
import { FormaPagoExportacion } from "src/app/models/Dte/FormaPagoExportacion";
import { IndicadorServicioExportacion } from "src/app/models/Dte/IndicadorServicio.enum";
import { IndicadorServicio } from '../../../../models/Dte/IndicadorServicio.enum';
@Component({
	selector: "app-resumen-lista-detalles",
	templateUrl: "./resumen-lista-detalles.component.html",
	styleUrls: ["./resumen-lista-detalles.component.scss"],
})
export class ResumenListaDetallesComponent implements OnInit {
	@ViewChild("currentSwal") private currentSwal: SwalComponent;
	private listaResumir: DetalleDte[];
	public montoIva: number = 0;
	public montoRetencionIva: number = 0;
	public porcentajeIva: number = environment.taxPercentage;
	public netoAfectoResumen: number = 0;
	public brutoAfectoResumen: number = 0;
	public exentoResumen: number = 0;
	public montoDescuento: number = 0;
	public totalResumen: number = 0;
	public totalRebajaAvaluo: number = 0;
	public subTotalResumen: number = 0;
	public subTotalExento: number = 0;
	public subTotalForeign: number = 0;
	public montoTotalImpuestosEspecificos: number = 0;
	private listaComisionResumir: ComisionRecargo[];
	public montoIvaComision: number = 0;
	public montoRetencionIvaComision: number = 0;
	public porcentajeIvaComision: number = environment.taxPercentage;
	public netoAfectoResumenComision: number = 0;
	public brutoAfectoResumenComision: number = 0;
	public exentoResumenComision: number = 0;
	public montoDescuentoComision: number = 0;
	public totalResumenComision: number = 0;
	public subTotalResumenComision: number = 0;
	public subTotalForeignComision: number = 0;
	public montoTotalImpuestosEspecificosComision: number = 0;
	private listaResumirObservable$: Observable<DetalleDte[]>;
	private listaComisionResumirObservable$: Observable<ComisionRecargo[]>;
	public otraMonedaResumen: OtraMoneda = new OtraMoneda();
	public opcionesObservable$: Observable<OptionsReferenceDteEmitido>;
	public divisasObservable$: Observable<Divisa[]>;
	public divisasList: Divisa[] = [];
	public opciones: OptionsReferenceDteEmitido = new OptionsReferenceDteEmitido();
	public totalesDteEmitido: TotalDteEmitido = new TotalDteEmitido();
	public totalesDteFormGroup: FormGroup;
	private tipoDteFullSource: TipoDte[]; //complete list of Dte types
	public tipoDteSource: TipoDte[]; //filtered list of Dte types for showing and selecting
	public tipoTrasladosSource: TipoTraslado[];
	public tipoDespachoSource: TipoDespacho[];
	public montoDescuentoForeign: number = 0;
	public todayString = moment.tz("America/Santiago");
	public lastDayOfMonth = moment().endOf("month");
	public minDateString = moment().add(-6, "months");
	public dontShowInTicket: boolean = true;
	public dontShowInGuide: boolean = true;
	public showInGuide: boolean = true;
	public showTransferType: boolean = false;
	public showPaymentType: boolean = true;
	public showDeliveryType: boolean = false;
	public showDueDate: boolean = true;
	public showDiscount: boolean = true;
	public showInExport: boolean = false;
	public showComission: boolean = false;
	public ShowInSettlement: boolean = false;
	public showIvaTerceros: boolean = false;
	public showInputIvaTerceros: boolean = false;
	private invoiceType$: Observable<InvoiceType>;
	private formatSizeList$: Observable<FormatoDte[]>;
	private subscriptions: Subscription[] = [];
	public currentInvoiceType: InvoiceType;
	public modalidadVentaSource: ModalidadVentas[] = [];
	public clausulaVentaSource: ClausulaVentas[] = [];
	public totalClausulaVenta: number = 0;
	public fleteResumen: number = 0;
	public seguroResumen: number = 0;
	private exportTransport$: Observable<ExportacionTransporteDte>;
	private trasporteExportacion: ExportacionTransporteDte;

	formasPagoExportacionSource = [
		{ id: 1, codigo: "COB1", descripcion: "COB1" },
		{ id: 11, codigo: "ACRED", descripcion: "ACREDIT" },
		{ id: 12, codigo: "CBOF", descripcion: "CBOF" },
		{ id: 2, codigo: "COBRANZA", descripcion: "COBRANZA" },
		{ id: 21, codigo: "S_PAGO", descripcion: "SIN PAGO" },
		{ id: 32, codigo: "ANTICIPO", descripcion: "ANTICIPO" },
		{ id: 50, codigo: "ANT_COB", descripcion: "ANTICIPO COBRANZA" },
		{ id: 60, codigo: "ANT_CRED", descripcion: "ANTICIPO CREDITO" },
	];
	tipoFacturaSource = [
		{ id: 0, tipo: "Afecta" },
		{ id: 1, tipo: "Exenta" },
	];
	formasPagoSource = [
		{ id: 1, nombreForma: "Contado" },
		{ id: 2, nombreForma: "Credito" },
		{ id: 3, nombreForma: "Sin Costo" },
	];
	// sizeFormat = [
	//    { id: 0, name: "Carta", size: 16 },
	//    { id: 1, name: "Semicarta", size: 8 },
	//    { id: 2, name: "Ticket", size: 10000 },
	// ];
	public sizeFormat: { id: number; name: string; size: number }[] = [];
	locale = {
		daysOfWeek: moment.weekdaysMin(),
		monthNames: moment.monthsShort(),
		firstDay: moment.localeData().firstDayOfWeek(),
		applyLabel: "ok",
		clearLabel: "Limpiar",
		format: "DD/MM/YYYY",
	};
	public validDate: boolean = true;
	constructor(private facturador: FacturacionIndividualService, private builder: FormBuilder, private localStorage: LocalStorageService, private ref: ChangeDetectorRef, private utilities: UtilitiesService, private currencyPipe: CurrencyPipe) {
		this.listaResumirObservable$ = this.facturador.detalleDteListObservable;
		this.listaComisionResumirObservable$ = this.facturador.detalleComisionDteListObservable;
		this.opcionesObservable$ = this.facturador.opcionesReferenciaObservable;
		this.divisasObservable$ = this.facturador.divisasListObservable;
		this.invoiceType$ = this.facturador.currentInvoiceTypeObservable;
		this.formatSizeList$ = this.facturador.formatSizeListObservable;
		this.exportTransport$ = this.facturador.exportacionTransporteObservable;
		this.tipoDteSource = JSON.parse(this.localStorage.getDteTypes()) as TipoDte[];
		this.tipoDteFullSource = JSON.parse(this.localStorage.getDteTypes()) as TipoDte[];
		this.tipoTrasladosSource = JSON.parse(this.localStorage.getTipoTraslados()) as TipoTraslado[];
		this.tipoDespachoSource = JSON.parse(this.localStorage.getTipoDespacho()) as TipoDespacho[];

		moment.tz.setDefault("America/Santiago");
	}

	ngOnInit(): void {
		this.createTotalesForm();
		const invoiceTypesSub = this.invoiceType$.subscribe((result) => {
			//hide due days,  change between Boleta pairs or Factura pairs related to exento or not exento
			this.modificationsByInvoiceType(result);
		});

		this.defaultOtraMonedaResumen();
		const listResumirSub = this.listaResumirObservable$.subscribe((list) => {
			this.listaResumir = [...list.filter((producto) => Object.keys(producto).length > 0)];
			if (this.listaResumir[0]) {
				this.calculateTotals();
			} else {
				this.resetTotals();
			}
		});
		const listComisionResumirSub = this.listaComisionResumirObservable$.subscribe((list) => {
			this.listaComisionResumir = [...list.filter((producto) => Object.keys(producto).length > 0)];
			if (this.listaComisionResumir[0]) {
				this.calculateComisionTotals();
				this.calculateTotals();
			}
			else {
				this.resetComisionTotals();
			}
			this.calculateTotals();

		});
		const divisasSub = this.divisasObservable$.subscribe((list) => {
			this.divisasList = list;
			if (this.divisasList[0]) {
				this.divisasList[0].nombre = "USD";
			}
		});
		const opcionesSub = this.opcionesObservable$.subscribe((opciones) => {
			this.opciones = opciones;

			this.otraMonedaResumen.tipoMoneda = this.opciones.tipoMoneda ? this.opciones.tipoMoneda : "CLP";
			//let foundedDivisa = this.divisasList.find((divisa) =>divisa.nombre.toUpperCase() == this.otraMonedaResumen.tipoMoneda );
			let foundedDivisa = opciones.valorTipoMoneda;
			this.otraMonedaResumen.tipoCambio = this.otraMonedaResumen.tipoMoneda != "CLP" && foundedDivisa != undefined ? foundedDivisa : 0;
			this.otraMonedaResumen.tipoMonedaAduana = this.opciones.tipoMonedaAduana ? this.opciones.tipoMonedaAduana : undefined;
			this.otraMonedaResumen.codigoMonedaAduana = this.opciones.codigoMonedaAduana ? this.opciones.codigoMonedaAduana : undefined;
			this.calculateTotals();
			this.calculateComisionTotals();

			//this.ref.detectChanges();
		});
		const exportSub = this.exportTransport$.subscribe((result) => {
			this.trasporteExportacion = result;
			this.calculateTotals();
		});
		const formatoSizeSub = this.formatSizeList$.subscribe((formatList) => {
			this.sizeFormat = [];
			formatList.forEach((formato, i) => {
				let size = { id: i, name: formato.formato, size: formato.maxLineas };
				this.sizeFormat.push(size);
			});
			this.totalesDteFormGroup.controls.formato.patchValue(this.sizeFormat[0]);
		});
		this.subscriptions = [listResumirSub, divisasSub, opcionesSub, invoiceTypesSub, listComisionResumirSub, exportSub, formatoSizeSub];
		this.onSubmit();
		this.ref.detectChanges();
	}

	resetComisionTotals() {
		this.montoIvaComision = 0;
		this.netoAfectoResumenComision = 0;
		this.brutoAfectoResumenComision = 0;
		this.exentoResumenComision = 0;
		this.totalResumenComision = 0;
		this.montoDescuentoComision = 0;
		this.subTotalResumenComision = 0;
		this.subTotalForeignComision = 0;
		this.montoTotalImpuestosEspecificosComision = 0;
	}
	
	ngOnChanges() {
		this.calculateTotals();
		this.calculateComisionTotals();
		this.ref.detectChanges();
	}

	calculateTotals() {
		this.montoIva = 0;
		this.netoAfectoResumen = 0;
		this.brutoAfectoResumen = 0;
		this.exentoResumen = 0;
		this.totalResumen = 0;
		this.totalRebajaAvaluo = 0;
		this.montoDescuento = 0;
		if (this.listaResumir[0].subtotal) {
			this.listaResumir.forEach((detalle) => {
				if (detalle.subtotal) {
					if (!detalle.esExento && this.opciones.sonDetallesConIVA) {
						this.brutoAfectoResumen += detalle.total;
					}
					// else if(!detalle.esExento && !detalle.impuestos && !this.opciones.sonDetallesConIVA){
					//   this.netoAfectoResumen += detalle.total;
					// }
					else if (detalle.esExento && this.currentInvoiceType == InvoiceType.FacturaExportacion) {
						this.exentoResumen += detalle.originalTotal;
					} else if (detalle.esExento) {
						this.exentoResumen += detalle.total;
					}
					this.totalRebajaAvaluo += detalle.rebajaAvaluo;
				}
			});

			if (this.opciones.tipoMoneda != "CLP") {
				//discount and tax calculation for foreign values
				let valorTipoCambio = this.opciones.valorTipoMoneda;

				this.montoDescuentoForeign = this.currentInvoiceType != 4 ? this.totalesDteFormGroup.controls.descuentoGlobal.value : Math.round(+(this.totalesDteFormGroup.controls.descuentoGlobal.value * valorTipoCambio).toFixed(0));
				//let valorTipoCambio = this.divisasList.find((divisa) => divisa.nombre.toUpperCase() == this.otraMonedaResumen.tipoMoneda).valorClp;
				if (this.opciones.sonDetallesConIVA && this.currentInvoiceType != InvoiceType.FacturaExportacion) {
					let valueWithTax = Math.round(+(this.montoDescuentoForeign * valorTipoCambio).toFixed(0));
					this.montoDescuento = Math.round(valueWithTax / (1 + this.porcentajeIva));
				} else {
					this.montoDescuento = +Math.round(+this.totalesDteFormGroup.controls.descuentoGlobal.value).toFixed(0);
				}
				if (this.opciones.sonDetallesConIVA) {
					this.montoDescuento = this.currentInvoiceType != InvoiceType.FacturaExportacion ? Math.round(+this.totalesDteFormGroup.controls.descuentoGlobal.value / (1 + this.porcentajeIva)) : this.montoDescuento;
					if (this.listaResumir.some((item) => item.impuestosAdicionales && item.impuestosAdicionales.length > 0) && this.currentInvoiceType != InvoiceType.FacturaExportacion) {
						this.getAllTotalsSpecificTaxItemsIncluded();
						this.totalesDteEmitido.montoImpuestos = this.montoTotalImpuestosEspecificos;
					} else {
						this.getTotalsMainTaxItemsIncluded();
					}
				} else {
					if (this.listaResumir.some((item) => item.impuestosAdicionales && item.impuestosAdicionales.length > 0)) {
						this.getAllTotalsSpecificTaxItemsExcluded();

						//if (this.opciones.tipoMoneda == "USD") {
						//	this.montoTotalImpuestosEspecificos = Math.round(this.montoTotalImpuestosEspecificos * this.opciones.valorTipoMoneda);
						//}
						this.totalesDteEmitido.montoImpuestos = this.montoTotalImpuestosEspecificos;
					} else {
						this.getTotalMainTaxItemsExcluded();
					}
					
				}
			} else if (this.opciones.tipoMoneda == "CLP") {
				this.montoDescuento = Math.round(this.totalesDteFormGroup.controls.descuentoGlobal.value);
				//DISCOUNT AND TAX CALCULATION FOR LOCAL VALUES
				if (this.opciones.sonDetallesConIVA) {
					if (this.currentInvoiceType != InvoiceType.Boleta && this.listaResumir.some((item) => item.impuestosAdicionales && item.impuestosAdicionales.length > 0)) {
						this.getAllTotalsSpecificTaxItemsIncluded();
						this.totalesDteEmitido.montoImpuestos = this.montoTotalImpuestosEspecificos;
					} else {
						this.getTotalsMainTaxItemsIncluded();
					}
				} else {
					if (this.currentInvoiceType != InvoiceType.Boleta && this.listaResumir.some((item) => (item.impuestosAdicionales && item.impuestosAdicionales.length > 0) || item.totalImpuestosAdicionales > 0)) {
						this.getAllTotalsSpecificTaxItemsExcluded();
						this.totalesDteEmitido.montoImpuestos = this.montoTotalImpuestosEspecificos;
					} else {
						this.getTotalMainTaxItemsExcluded();
					}
				}
			}
			if (this.currentInvoiceType == InvoiceType.Boleta && this.totalesDteEmitido.codigoTipoDte != 41) {
				this.totalResumen = this.opciones.sonDetallesConIVA ? this.montoIva + this.netoAfectoResumen + this.exentoResumen + this.montoTotalImpuestosEspecificos - (this.montoTotalImpuestosEspecificos > 0 ? this.montoDescuento / (1 + this.porcentajeIva) : 0) : this.montoIva + this.netoAfectoResumen + this.exentoResumen - (this.opciones.sonDetallesConIVA ? Math.round(this.montoDescuento / (1 + this.porcentajeIva)) : this.montoDescuento) + this.montoTotalImpuestosEspecificos;
			} else if (this.totalesDteEmitido.codigoTipoDte == 34 || this.totalesDteEmitido.codigoTipoDte == 41) {
				this.totalResumen = this.currentInvoiceType != 4 ? this.montoIva + this.netoAfectoResumen + this.exentoResumen - (this.opciones.sonDetallesConIVA && this.netoAfectoResumen > 0 ? Math.round(this.montoDescuento / (1 + this.porcentajeIva)) : this.montoDescuento) + this.montoTotalImpuestosEspecificos : this.exentoResumen - this.montoDescuento;
			} else {
				this.totalResumen = this.currentInvoiceType != 4 ? this.montoIva + this.netoAfectoResumen + this.exentoResumen - this.montoDescuento + this.montoTotalImpuestosEspecificos : this.exentoResumen - this.montoDescuento;
			}
			this.totalesDteEmitido.netoDte = this.netoAfectoResumen;
			this.totalesDteEmitido.exentoDte = this.exentoResumen;
			this.totalesDteEmitido.ivaDte = this.montoIva;
			this.totalesDteEmitido.totalDte = this.totalResumen;
			this.totalesDteEmitido.tipoTraslado = this.totalesDteFormGroup.controls.tipoTraslado.value.id;
			this.totalesDteEmitido.tipoDespacho = this.totalesDteFormGroup.controls.tipoDespacho.value.id;
			this.totalesDteEmitido.formaPago = this.totalesDteFormGroup.controls.formaPago.value;
			this.totalesDteEmitido.formaPagoExportacion = this.totalesDteFormGroup.controls.formaPagoExportacion.value.id;
			this.totalesDteEmitido.fechaEmision = moment.tz(this.totalesDteFormGroup.controls.fechaEmision.value.startDate, "America/Santiago").toDate();
			this.totalesDteEmitido.descuentoGlobal = this.opciones.sonDetallesConIVA ? Math.round(this.montoDescuento / (1 + this.porcentajeIva)) : this.montoDescuento; //this.totalesDteFormGroup.controls.descuentoGlobal.value;
			this.totalesDteEmitido.formato = this.totalesDteFormGroup.controls.formato.value;
			this.totalesDteEmitido.descuentoRecargoEnt = this.setGlobalDiscountObject(this.montoDescuento);
			this.checkTaxesIntegrity();
			this.onSubmit();
		}
	}
	calculateComisionTotals() {
		this.montoIvaComision = 0;
		this.netoAfectoResumenComision = 0;
		this.brutoAfectoResumenComision = 0;
		this.exentoResumenComision = 0;
		this.totalResumenComision = 0;
		this.montoDescuentoComision = 0;

		this.listaComisionResumir.forEach((detalle) => {
			this.netoAfectoResumenComision += detalle.neto;
			this.exentoResumenComision += detalle.exento;
		});
		this.netoAfectoResumenComision = this.listaComisionResumir.reduce((sum, item) => (item.neto != 0 ? sum + item.neto : sum + 0), 0);
		this.montoIvaComision = Math.round(this.porcentajeIva * this.netoAfectoResumenComision);

		this.totalResumenComision = this.montoIvaComision + this.netoAfectoResumenComision + this.exentoResumenComision;

		this.totalesDteEmitido.ivaComisionCargos = this.montoIvaComision;
		this.totalesDteEmitido.netoComisionCargos = this.netoAfectoResumenComision;
		this.totalesDteEmitido.exentoComisionCargos = this.exentoResumenComision;
		this.totalesDteEmitido.totalComisionCargos = this.totalResumenComision;
		this.onSubmit();
	}

	detectChangeResumenDate(event) {
		if (event.startDate != null) {
			let fechaEmision = moment.tz(event.startDate, "DD/MM/YYYY", "America/Santiago").toDate();

			this.totalesDteEmitido.fechaEmision = fechaEmision;
			this.totalesDteFormGroup.controls.fechaEmision.patchValue(event);
			this.onSubmit();
		} else if (event.target != null && event.target.value != null) {
			this.validDate = moment.tz(event.target.value, "DD/MM/YYYY", "America/Santiago").isValid();
			if (this.validDate) {
				let obj: any = new Object();
				obj.startDate = moment.tz(event.target.value, "DD/MM/YYYY", "America/Santiago");
				this.totalesDteEmitido.fechaEmision = moment(obj.startDate).toDate();
				this.totalesDteFormGroup.controls.fechaEmision.patchValue(obj);
				this.onSubmit();
			}
		}
	}
	createTotalesForm() {
		this.totalesDteFormGroup = this.builder.group({
			tipoDte: [this.tipoDteSource[0], { validator: Validators.required }],
			formaPago: [this.formasPagoSource[0]],
			tipoTraslado: [this.tipoTrasladosSource[0]],
			tipoDespacho: [this.tipoDespachoSource[0]],
			fechaEmision: [{ startDate: moment.tz("America/Santiago"), endDate: moment.tz("America/Santiago") }],
			descuentoGlobal: [0, [NonNegativeNumberValidator]],
			formato: [this.sizeFormat[0]],
			diasVencimiento: [0, [NonNegativeNumberValidator]],
			ivaTerceros: [this.montoIva, [PositiveNumberValidator]],
			ivaPropio: [0, [PositiveNumberValidator]],
			modalidadVenta: [this.modalidadVentaSource[this.utilities.getIndexForArrayItem("sigla", "FIRME", this.modalidadVentaSource)]],
			clausulaVenta: [this.clausulaVentaSource[this.utilities.getIndexForArrayItem("sigla", "CIF", this.clausulaVentaSource)]],
			indicadoresServicio: [0],
			formaPagoExportacion: [this.formasPagoExportacionSource[2]],
		});
		this.totalesDteFormGroup.get("tipoDte").disable();
		this.totalesDteFormGroup.controls.formato.patchValue(this.sizeFormat[0]);
	}

	onSubmit() {
		if (this.showInputIvaTerceros) {
			this.totalesDteFormGroup.controls.ivaTerceros.enable();
			this.totalesDteFormGroup.controls.ivaTerceros.setValidators([PositiveNumberValidator]);
		} else {
			this.totalesDteFormGroup.controls.ivaTerceros.disable();
		}
		if (this.totalesDteFormGroup.valid && this.validDate) {
			var ivaPropio = Number.parseInt(this.totalesDteFormGroup.controls.ivaPropio.value);
			var ivaTerceros = Number.parseInt(this.totalesDteFormGroup.controls.ivaTerceros.value);
			if (ivaPropio <= 0 || ivaPropio + ivaTerceros != Math.round(this.montoIva)) {
				this.totalesDteFormGroup.controls.ivaTerceros.patchValue(Math.round(this.montoIva));
				this.totalesDteFormGroup.controls.ivaPropio.patchValue(0);
			}
			if (this.opciones.tipoMoneda != "CLP" && this.currentInvoiceType != 4 && this.montoDescuentoForeign != this.totalesDteFormGroup.controls.descuentoGlobal.value) {
				this.refreshDiscount();
			}
			let completeTipoDteList = JSON.parse(this.localStorage.getDteTypes()) as TipoDte[];
			let tipoDte = new TipoDte();
			tipoDte = this.totalesDteFormGroup.controls.tipoDte.value;
			if (tipoDte.codigosii != 52) {
				let newCodigoSii = this.setTipoDteAfectoExento(this.listaResumir, tipoDte);
				if (newCodigoSii == tipoDte.codigosii) {
					this.totalesDteEmitido.tipoDteId = tipoDte.tipoDteId;
					this.totalesDteEmitido.codigoTipoDte = tipoDte.codigosii;
				} else {
					let changedDte: TipoDte = completeTipoDteList.find((dteType) => dteType.codigosii == newCodigoSii);
					this.totalesDteFormGroup.controls.tipoDte.patchValue(this.tipoDteSource.find((type) => type.tipoDteId == changedDte.tipoDteId));
					this.totalesDteEmitido.tipoDteId = changedDte.tipoDteId;
					this.totalesDteEmitido.codigoTipoDte = changedDte.codigosii;
				}
			} else {
				this.totalesDteEmitido.tipoDteId = tipoDte.tipoDteId;
				this.totalesDteEmitido.codigoTipoDte = tipoDte.codigosii;
			}
			if (this.totalResumenComision != 0) this.totalResumen = this.totalResumen - this.totalResumenComision;
			this.totalesDteEmitido.tipoTraslado = this.totalesDteFormGroup.controls.tipoTraslado.value.id;
			this.totalesDteEmitido.tipoDespacho = this.totalesDteFormGroup.controls.tipoDespacho.value.id;
			this.totalesDteEmitido.formaPago = this.totalesDteFormGroup.controls.formaPago.value.id;
			this.totalesDteEmitido.fechaEmision = moment.tz(this.totalesDteFormGroup.controls.fechaEmision.value.startDate, "America/Santiago").toDate();
			this.totalesDteEmitido.descuentoGlobal = this.montoDescuento; //+this.totalesDteFormGroup.controls.descuentoGlobal.value;
			this.totalesDteEmitido.netoDte = this.totalesDteEmitido.descuentoGlobal > 0 && this.netoAfectoResumen > 0 ? this.subTotalResumen : this.netoAfectoResumen;
			this.totalesDteEmitido.exentoDte = this.subTotalExento > 0 ? this.subTotalExento : this.exentoResumen;
			this.totalesDteEmitido.ivaDte = this.montoIva;
			this.totalesDteEmitido.totalDte = this.totalResumen;
			this.totalesDteEmitido.formato = this.totalesDteFormGroup.controls.formato.value;
			this.totalesDteEmitido.diasVencimiento = this.totalesDteFormGroup.controls.diasVencimiento.value;
			if (!(this.opciones.tipoMoneda == "CLP")) {
				this.updateAlternResumen();
			}
			if (this.showInputIvaTerceros) {
				this.totalesDteEmitido.TieneIvaTerceros = true;
				this.totalesDteEmitido.ivaTerceros = Number.parseInt(this.totalesDteFormGroup.controls.ivaTerceros.value);
				this.totalesDteEmitido.ivaPropio = Number.parseInt(this.totalesDteFormGroup.controls.ivaPropio.value);
			} else {
				this.totalesDteEmitido.TieneIvaTerceros = false;
				this.totalesDteEmitido.ivaTerceros = 0;
				this.totalesDteEmitido.ivaPropio = 0;
			}
			this.totalesDteEmitido.otraMonedaEnt = this.otraMonedaResumen;
			// if(this.totalesDteFormGroup.controls.tipoDte.value.codigosii == 52 ) {
			//   if(this.totalesDteFormGroup.controls.tipoTraslado.value.id== 6){
			//     this.netoAfectoResumen = 0;
			//     this.subTotalResumen = 0;
			//     this.exentoResumen = 0;
			//     this.montoIva = 0;
			//     this.montoRetencionIva = 0;
			//     this.montoTotalImpuestosEspecificos = 0;
			//     this.totalResumenComision = 0;
			//     this.totalResumen = 0;
			//   }
			// }
			if (this.currentInvoiceType == InvoiceType.FacturaCompra) {
				//this.montoRetencionIva = this.montoIva;
				// let totalDescontadoRetencion = this.totalesDteEmitido.totalDte-this.totalesDteEmitido.retencionIva;
				// this.totalesDteEmitido.totalDte = totalDescontadoRetencion;
				// this.totalResumen = totalDescontadoRetencion;
				this.montoRetencionIva = this.totalesDteEmitido.calcularRetenciones(this.listaResumir, !this.opciones.sonDetallesConIVA, this.porcentajeIva);
				this.totalesDteEmitido.retencionIva = this.montoRetencionIva;
				this.totalResumen = this.totalesDteEmitido.tieneRetenciones();
			} else if (this.currentInvoiceType == InvoiceType.FacturaExportacion) {
				this.totalesDteEmitido.indicadorServicio = this.totalesDteFormGroup.controls.indicadoresServicio.value;
				this.setTotalsForClausulaVenta();
				this.updateAlternResumen();
			}
			this.facturador.updateTotales(this.totalesDteEmitido);
		}
	}

	updateFormaPago(event) {
		var diasCredito = event.nombreForma == "Contado" ? "0" : "30";
		this.totalesDteFormGroup.controls.diasVencimiento.setValue(diasCredito);
	}
	refreshTotalesForm(totales: TotalDteEmitido) {
		this.totalesDteFormGroup.patchValue(totales);
		if (!totales.formaPago) {
			this.totalesDteFormGroup.patchValue(
				{
					formaPago: [this.formasPagoSource[0]],
				},
				{ onlySelf: true }
			);
		}
	}

	updateAlternResumen() {
		//update the OtraMoneda instance to show the  total value of the Dte in foreign value
		this.otraMonedaResumen.tipoMoneda = this.opciones.tipoMoneda;
		if (this.divisasList.length > 0 && this.otraMonedaResumen.tipoMoneda != "CLP" && this.otraMonedaResumen.tipoCambio > 0 && this.otraMonedaResumen.tipoMoneda && this.currentInvoiceType != InvoiceType.FacturaExportacion) {
			//this.otraMonedaResumen.tipoCambio = this.divisasList.find((divisa) => divisa.nombre.toUpperCase() == this.otraMonedaResumen.tipoMoneda).valorClp;
			this.otraMonedaResumen.tipoCambio = this.opciones.valorTipoMoneda;
			this.otraMonedaResumen.montoNeto = +(this.totalesDteEmitido.netoDte / this.otraMonedaResumen.tipoCambio).toFixed(2);
			this.otraMonedaResumen.montoExento = +(this.totalesDteEmitido.exentoDte / this.otraMonedaResumen.tipoCambio).toFixed(2);
			this.otraMonedaResumen.iva = +(this.totalesDteEmitido.ivaDte / this.otraMonedaResumen.tipoCambio).toFixed(2);
			this.otraMonedaResumen.montoTotal = +(this.totalesDteEmitido.totalDte / this.otraMonedaResumen.tipoCambio).toFixed(2);
			this.otraMonedaResumen.imptoEspecifico = +(this.totalesDteEmitido.montoImpuestos / this.otraMonedaResumen.tipoCambio).toFixed(2);
			this.subTotalForeign = this.otraMonedaResumen.montoNeto - this.montoDescuentoForeign;
		} else if (this.currentInvoiceType == InvoiceType.FacturaExportacion) {
			//let foundedCurrency = this.divisasList.find((divisa) => divisa.nombre.toUpperCase() == this.otraMonedaResumen.tipoMoneda);
			//let baseValorCLP =  foundedCurrency?foundedCurrency.valorClp:1;
			let foundedCurrency = this.opciones.valorTipoMoneda;
			let baseValorCLP = this.opciones.tipoMoneda.toLowerCase() == "clp" ? 1 : foundedCurrency;
			this.otraMonedaResumen.tipoCambio = baseValorCLP;
			//this.otraMonedaResumen.montoNeto = this.totalesDteEmitido.netoDte;
			this.otraMonedaResumen.montoExento = Math.round(this.totalesDteEmitido.exentoDte * baseValorCLP);
			this.otraMonedaResumen.montoTotal = Math.round(this.totalesDteEmitido.totalDte * baseValorCLP);
			this.otraMonedaResumen.montoClausulaVenta = Math.round(this.totalClausulaVenta * baseValorCLP);
			this.otraMonedaResumen.flete = Math.round(this.fleteResumen * baseValorCLP);
			this.otraMonedaResumen.seguro = Math.round(this.seguroResumen * baseValorCLP);
			this.otraMonedaResumen.montoTipoMoneda = this.opciones.valorTipoMoneda;
		}
	}
	refreshDiscount() {
		//when used in foreign currency, update the discount value in CLP
		this.montoDescuentoForeign = this.currentInvoiceType != 4 ? this.totalesDteFormGroup.controls.descuentoGlobal.value : Math.round(+(this.totalesDteFormGroup.controls.descuentoGlobal.value * this.opciones.valorTipoMoneda).toFixed(0)); //this.totalesDteFormGroup.controls.descuentoGlobal.value;

		// let valorTipoCambio = this.divisasList.find(
		//   (divisa) =>
		//     divisa.nombre.toUpperCase() == this.otraMonedaResumen.tipoMoneda
		// ).valorClp;
		let valorTipoCambio = this.otraMonedaResumen.tipoCambio;
		this.montoDescuento = this.currentInvoiceType != 4 ? Math.round(+(this.montoDescuentoForeign * valorTipoCambio).toFixed(0)) : this.totalesDteFormGroup.controls.descuentoGlobal.value;
		this.montoIva = Math.round(this.porcentajeIva * (this.netoAfectoResumen - this.montoDescuento));
		this.totalResumen = this.montoIva + this.netoAfectoResumen + this.exentoResumen;
		if (this.totalResumenComision != 0) this.totalResumen = this.totalResumen + this.totalResumenComision;
		this.totalesDteEmitido.netoDte = this.netoAfectoResumen;
		this.totalesDteEmitido.exentoDte = this.exentoResumen;
		this.totalesDteEmitido.ivaDte = this.montoIva;
		this.totalesDteEmitido.totalDte = this.totalResumen;
	}

	defaultOtraMonedaResumen() {
		this.otraMonedaResumen.montoNeto = 0;
		this.otraMonedaResumen.montoExento = 0;
		this.otraMonedaResumen.iva = 0;
		this.otraMonedaResumen.montoTotal = 0;
	}

	setGlobalDiscountObject(discountValue: number) {
		let descuentoGlobal: DescuentoRecargo = new DescuentoRecargo();
		descuentoGlobal.numero = 0;
		descuentoGlobal.tipoMovimiento = TipoMovimiento.D;
		descuentoGlobal.descripcion = "Descuento sobre subtotal";
		descuentoGlobal.tipoValor = ExpresionDinero.$;

		descuentoGlobal.IndicadorExento = IndicadorExento["No facturable"];
		descuentoGlobal.valor = +discountValue;
		return descuentoGlobal;
	}

	setTipoDteAfectoExento(list: DetalleDte[], dteType: TipoDte): number {
		//check the dte list and change the Dte type if the conditions are ok
		let dteTypeSelected: TipoDte = dteType;
		if (dteTypeSelected.codigosii == 33 || dteTypeSelected.codigosii == 34) {
			return this.AllListElementsAreExento(list) ? 34 : 33;
		} else if (dteTypeSelected.codigosii == 39 || dteTypeSelected.codigosii == 41) {
			return this.AllListElementsAreExento(list) ? 41 : 39;
		} else {
			return dteTypeSelected.codigosii;
		}
	}

	AllListElementsAreExento(list: DetalleDte[]): boolean {
		return list.every((detail) => detail.esExento == true);
	}

	calculateListWithTax(list: DetalleDte[]) {
		//change the value for each item excludying the tax value
		return list.map((detail) => (detail = this.setDetailWithoutTax(detail)));
	}

	setDetailWithoutTax(detail) {
		detail.precioUnitario = detail.precioUnitario / (1 + this.porcentajeIva);
		detail.recargo = detail.recargo / (1 + this.porcentajeIva);
		detail.descuento = detail.descuento / (1 + this.porcentajeIva);
		detail.subtotal = detail.subtotal / (1 + this.porcentajeIva);
		detail.total = detail.total / (1 + this.porcentajeIva);
		return detail;
	}

	modificationsByInvoiceType(type: InvoiceType) {
		switch (type) {
			case InvoiceType.Factura: {
				this.tipoDteSource = this.tipoDteFullSource.filter((dteType) => dteType.codigosii == 33 || dteType.codigosii == 34);
				this.showComission = false;
				this.currentInvoiceType = type;
				break; //this.totalesDteFormGroup.controls.tipoDte.patchValue(this.tipoDteSource[0])
			}
			case InvoiceType.Boleta: {
				this.tipoDteSource = this.tipoDteFullSource.filter((dteType) => dteType.codigosii == 39 || dteType.codigosii == 41);
				//this.dontShowInTicket = true;
				this.showComission = false;
				this.showPaymentType = false;
				this.showDueDate = false;
				this.showDiscount = false;
				this.currentInvoiceType = type;
				this.totalesDteFormGroup.controls.diasVencimiento.patchValue(0);
				break;
			}
			case InvoiceType.GuiaDespacho: {
				this.tipoDteSource = this.tipoDteFullSource.filter((dteType) => dteType.codigosii == 52);

				this.currentInvoiceType = type;
				this.showDeliveryType = true;
				this.showTransferType = true;
				this.ShowInSettlement = false;
				this.showPaymentType = false;
				this.showDiscount = false;
				this.showComission = false;
				this.showDueDate = false;
				this.totalesDteFormGroup.controls.diasVencimiento.patchValue(0);
				this.todayString = this.lastDayOfMonth;
				break;
			}
			case InvoiceType.FacturaCompra: {
				this.currentInvoiceType = type;
				this.showComission = false;
				this.ShowInSettlement = false;
				this.tipoDteSource = [this.tipoDteFullSource.find((dteType) => dteType.codigosii == 46)];
				this.totalesDteFormGroup.controls.diasVencimiento.patchValue(0);
				break;
			}
			case InvoiceType.FacturaExportacion: {
				this.showInExport = true;
				this.currentInvoiceType = type;
				this.ShowInSettlement = false;
				this.showComission = false;
				this.tipoDteSource = [this.tipoDteFullSource.find((dteType) => dteType.codigosii == 110)];
				this.modalidadVentaSource = this.localStorage.getCodigosAduana().modalidadVentas;
				this.clausulaVentaSource = this.localStorage.getCodigosAduana().clausulaVentas;
				this.utilities.sortAlphabeth(this.modalidadVentaSource, "sigla");
				this.utilities.sortAlphabeth(this.clausulaVentaSource, "sigla");
				this.totalesDteFormGroup.controls.modalidadVenta.patchValue(this.modalidadVentaSource[this.utilities.getIndexForArrayItem("sigla", "FIRME", this.modalidadVentaSource)]);
				this.totalesDteFormGroup.controls.clausulaVenta.patchValue(this.clausulaVentaSource[this.utilities.getIndexForArrayItem("sigla", "CIF", this.clausulaVentaSource)]);
				this.totalesDteFormGroup.controls.formaPagoExportacion.patchValue(this.formasPagoExportacionSource[this.utilities.getIndexForArrayItem("descripcion", "COBRANZA", this.formasPagoExportacionSource)]);
				break;
			}

			case InvoiceType.LiquidacionFactura: {
				this.tipoDteSource = this.tipoDteFullSource.filter((dteType) => dteType.codigosii == 43);
				this.currentInvoiceType = type;
				this.showComission = true;
				this.showDiscount = false;
				this.ShowInSettlement = true;
				this.totalesDteFormGroup.controls.diasVencimiento.patchValue(0);
				break;
			}

			case InvoiceType.NotaCredito: {
				this.tipoDteSource = this.tipoDteFullSource.filter((dteType) => dteType.codigosii == 61);
				this.showComission = false;
				this.ShowInSettlement = false;
				this.showDiscount = false;
				this.totalesDteFormGroup.controls.diasVencimiento.patchValue(0);
				break;
			}

			case InvoiceType.NotaDebito: {
				this.tipoDteSource = this.tipoDteFullSource.filter((dteType) => dteType.codigosii == 56);
				this.showComission = false;
				this.ShowInSettlement = false;
				this.showDiscount = false;
				this.totalesDteFormGroup.controls.diasVencimiento.patchValue(0);
				break;
			}
		}
		this.totalesDteFormGroup.controls.tipoDte.patchValue(this.tipoDteSource[0]);
		if (this.tipoDteSource[0].codigosii == 33) {
			this.showIvaTerceros = true;
		} else this.showIvaTerceros = false;
	}

	getTaxesFromDetailsNeto(detalles: DetalleDte[]) {
		let totalTaxes;
		detalles.forEach((prod) => {
			if (prod.impuestosAdicionales.length > 0) {
				prod.impuestosAdicionales.forEach((tax) => {
					totalTaxes += Math.round(prod.total * (tax.valor / 100));
				});
			}
		});
		return totalTaxes;
	}

	getNetoTotalFromTaxedDetailsIncluded(detalles: DetalleDte[]) {
		//
		this.checkCorrectTaxInDetail();
		let netoTotal: number = 0;

		detalles.forEach((detalle) => {
			if (detalle.impuestosAdicionales && !detalle.esExento) {
				let sumTaxRates = this.getSumOfTaxesRatesInItem(detalle);
				netoTotal += Math.round(detalle.total / (1 + sumTaxRates / 100 + this.porcentajeIva)) - detalle.rebajaAvaluo;
			} else {
				netoTotal += Math.round(detalle.total / (1 + this.porcentajeIva)) - detalle.rebajaAvaluo;
			}
		});

		return netoTotal;
	}
	getSumOfTaxesRatesInItem(item: DetalleDte) {
		return item.impuestosAdicionales.reduce((sumTaxRates, imptoAdicional) => sumTaxRates + imptoAdicional.tasa, 0);
	}

	getSpecificTaxesTotalFromItemListIncluded(descuento: number) {
		//the total of specific tax has to be calculated from each detail
		let totalSpecificTaxValue = 0;
		if (this.currentInvoiceType != InvoiceType.Boleta) {
			this.listaResumir.forEach((item) => {
				if (!item.esExento && item.impuestosAdicionales && item.impuestosAdicionales.length > 0) {
					let sumTaxRates = this.getSumOfTaxesRatesInItem(item);
					let netoTotalItem = item.total / (1 + sumTaxRates / 100 + this.porcentajeIva) - descuento;
					item.totalImpuestosAdicionales = 0;
					item.impuestosAdicionales.forEach((imptoAdicional) => {
						let imptoSinRedond = netoTotalItem * (imptoAdicional.tasa / 100);
						imptoAdicional.valor = Math.round(imptoSinRedond);
						item.totalImpuestosAdicionales += imptoAdicional.valor;
					});
				}
				totalSpecificTaxValue += !item.esExento ? item.totalImpuestosAdicionales : 0;
			});
		}
		return totalSpecificTaxValue;
	}

	getAllTotalsSpecificTaxItemsIncluded() {
		//not all items contribute to MainTax / IVA
		//from net you can get the MainTax, then montoIva and subTotalResumen are related to the netoAfectoResumen
		if (this.currentInvoiceType == InvoiceType.Boleta) {
			this.netoAfectoResumen = this.getNetoTotalFromTaxedDetailsIncluded(this.listaResumir);
			let descuentoNeto = this.montoDescuento / (1 + this.porcentajeIva);
			this.montoIva = Math.round(this.porcentajeIva * (this.netoAfectoResumen - descuentoNeto));
			//this.montoTotalImpuestosEspecificos = this.getSpecificTaxesTotalFromItemListIncluded(descuentoNeto);
			this.subTotalResumen = this.netoAfectoResumen - descuentoNeto + this.exentoResumen;
		} else {
			this.netoAfectoResumen = this.getNetoTotalFromTaxedDetailsIncluded(this.listaResumir);
			let descuentoNeto = this.montoDescuento;
			this.montoIva = Math.round(this.porcentajeIva * (this.netoAfectoResumen - descuentoNeto));
			this.montoTotalImpuestosEspecificos = this.getSpecificTaxesTotalFromItemListIncluded(descuentoNeto);
			this.subTotalResumen = this.netoAfectoResumen - descuentoNeto + this.exentoResumen;
		}
	}

	getTotalsMainTaxItemsIncluded() {
		//CON IVA
		/* ITEM PRICE INCLUDED THE TAXES SO NET VALUE IS OBTAINED FROM ARRAY OF ITEMS
	 Previously the  gross total is obtained directly from the sum of total details
	then it's used to get the net total */
		if (this.currentInvoiceType == InvoiceType.FacturaExportacion) {
			this.netoAfectoResumen = 0;
			this.montoIva = 0;
			this.subTotalResumen = this.exentoResumen - this.montoDescuento;
			if (this.subTotalResumen != this.brutoAfectoResumen) {
				this.approximateTotalForTaxIncludedItems();
			}
			this.montoTotalImpuestosEspecificos = 0;
		} else if (this.currentInvoiceType == InvoiceType.Boleta) {
			this.netoAfectoResumen = this.brutoAfectoResumen > 0 ? (this.brutoAfectoResumen - this.montoDescuento) / (1 + this.porcentajeIva) : 0;
			this.montoIva = this.netoAfectoResumen > 0 ? this.netoAfectoResumen * this.porcentajeIva : 0;
			this.subTotalResumen = this.netoAfectoResumen + this.exentoResumen - this.montoDescuento;
			if (this.netoAfectoResumen + this.montoIva != this.brutoAfectoResumen + this.montoDescuento) {
				this.approximateTotalForTaxIncludedItems();
			}
		} else {
			this.netoAfectoResumen = this.brutoAfectoResumen / (1 + this.porcentajeIva);
			this.montoIva = this.netoAfectoResumen > 0 ? this.porcentajeIva * (this.netoAfectoResumen - this.montoDescuento) : 0;

			if (this.totalRebajaAvaluo > 0) {
				let totalRebajado = this.brutoAfectoResumen - this.totalRebajaAvaluo;
				if (totalRebajado < 0) totalRebajado = 0;
				const ivaRebajado = totalRebajado / (1 + this.porcentajeIva) * this.porcentajeIva;
				this.montoIva = ivaRebajado;
				this.netoAfectoResumen = this.brutoAfectoResumen - ivaRebajado;
			}

			this.subTotalResumen = this.netoAfectoResumen - this.montoDescuento + this.exentoResumen;
			if (this.subTotalResumen + this.montoIva + this.exentoResumen != this.brutoAfectoResumen) {
				this.approximateTotalForTaxIncludedItems();
			}
			this.montoTotalImpuestosEspecificos = 0;
		}
	}

	getNetoTotalFromTaxedItemExcluded(detalles: DetalleDte[]) {
		let netoTotal = 0;
		detalles.forEach((detalle) => {
			if (!detalle.esExento) {
				netoTotal += detalle.total - detalle.rebajaAvaluo;
			}
		});
		return netoTotal;
	}

	getSpecificTaxesTotalFromItemListExcluded() {
		let totalSpecificTaxes = 0;
		if (this.currentInvoiceType != InvoiceType.Boleta) {
			this.checkCorrectTaxInDetail();
			if (this.listaResumir.some((detail) => detail.totalImpuestosAdicionales > 0)) {
				this.listaResumir.forEach((detail) => {
					if (detail.totalImpuestosAdicionales > 0) {
						totalSpecificTaxes += detail.totalImpuestosAdicionales;
					}
				});
				return totalSpecificTaxes;

			}
			this.listaResumir.forEach((item) => {
				if (!item.esExento && item.impuestosAdicionales && item.impuestosAdicionales.length > 0) {
					item.impuestosAdicionales.forEach((impAdic) => {
						//totalSpecificTaxes += Math.round(impAdic.valor*item.cantidad);
						totalSpecificTaxes += +(impAdic.valor * item.cantidad).toFixed(2);
					});
				}
			});
		}
		return totalSpecificTaxes;
	}
	checkCorrectTaxInDetail() {
		this.listaResumir.forEach((item) => {
			if (item.relatedProductId != null) {
				let impuestosFromProduct = item.relatedProduct.impuestos;
				item.impuestosAdicionales = [];
				item.totalImpuestosAdicionales = 0;

				if (impuestosFromProduct) {
					impuestosFromProduct.forEach((i) => {
						let impuestoAdicional = new DetalleDteImpuestoAdicional();
						impuestoAdicional.codigoSii = i.tipoImpuesto;
						impuestoAdicional.nombreImp = i.nombre;
						if (this.opciones.sonDetallesConIVA) {
							impuestoAdicional.valor = Math.round((i.valor / 100) * (item.total / (1.19 + i.valor / 100)));
						} else {
							impuestoAdicional.valor = Math.round((i.valor / 100) * item.total);
						}
						impuestoAdicional.nroImp = impuestosFromProduct.indexOf(i) + 1;
						impuestoAdicional.tasa = i.valor;
						impuestoAdicional.impuestoIdRelated = i.impuestoId;
						item.totalImpuestosAdicionales += impuestoAdicional.valor;
						item.impuestosAdicionales.push(impuestoAdicional);
					});
				}
			}
			else if (item.impuestosAdicionales && item.impuestosAdicionales.length > 0) {
				item.totalImpuestosAdicionales = 0;
				item.impuestosAdicionales.forEach((imp, index) => {
				  imp.nroImp = index + 1;
				  if (this.opciones.sonDetallesConIVA) {
					imp.valor = Math.round((imp.tasa / 100) * (item.total / (1.19 + imp.tasa / 100)));
				  } else {
					imp.valor = Math.round((imp.tasa / 100) * item.total);
				  }
				  item.totalImpuestosAdicionales += imp.valor;
				});
			  }
		});
	}
	getAllTotalsSpecificTaxItemsExcluded() {
		let netoFromTaxedExcludedItems = this.getNetoTotalFromTaxedItemExcluded(this.listaResumir);
		this.netoAfectoResumen = this.netoAfectoResumen > 0 ? this.netoAfectoResumen + netoFromTaxedExcludedItems : netoFromTaxedExcludedItems;
		this.montoDescuento = +this.totalesDteFormGroup.controls.descuentoGlobal.value;
		this.montoIva = Math.round(this.porcentajeIva * (this.netoAfectoResumen - this.montoDescuento));
		this.montoTotalImpuestosEspecificos = this.getSpecificTaxesTotalFromItemListExcluded();
		this.subTotalResumen = this.netoAfectoResumen > 0 ? this.netoAfectoResumen - this.montoDescuento + this.exentoResumen : 0 + this.exentoResumen - this.montoDescuento;
		this.subTotalExento = this.netoAfectoResumen <= 0 ? this.netoAfectoResumen - this.montoDescuento + this.exentoResumen : 0 + this.exentoResumen - this.montoDescuento; //works only if not afecto items
	}

	getTotalMainTaxItemsExcluded() {
		this.netoAfectoResumen = this.listaResumir.reduce((sum, item) => (!item.esExento && item.total != undefined ? sum + item.total : sum + 0), 0);
		if (this.opciones.tipoMoneda == "CLP") {
			this.montoDescuento = +this.totalesDteFormGroup.controls.descuentoGlobal.value;
			this.subTotalExento = this.netoAfectoResumen <= 0 ? this.exentoResumen - this.montoDescuento : 0; //works only if not afecto items
		}
		if (this.currentInvoiceType == InvoiceType.LiquidacionFactura) {
			this.montoIva = this.netoAfectoResumen != 0 ? Math.round(this.porcentajeIva * (this.netoAfectoResumen - this.montoDescuento)) : 0;
		}
		else{
			this.montoIva = this.netoAfectoResumen > 0 ? Math.round(this.porcentajeIva * (this.netoAfectoResumen - this.montoDescuento)) : 0;
		}
		if (this.currentInvoiceType == InvoiceType.FacturaExportacion) {
			this.montoDescuento = +this.totalesDteFormGroup.controls.descuentoGlobal.value;
			this.montoDescuentoForeign = Math.round(+(this.montoDescuento * this.opciones.valorTipoMoneda).toFixed(0));
			this.ref.detectChanges();
			this.montoIva = 0;
		}else if (this.currentInvoiceType == InvoiceType.LiquidacionFactura) { 
			this.subTotalResumen = this.netoAfectoResumen != 0 ? this.netoAfectoResumen - this.montoDescuento + this.exentoResumen : 0 + this.exentoResumen - this.montoDescuento;
		}
		else {
			this.subTotalResumen = this.netoAfectoResumen > 0 ? this.netoAfectoResumen - this.montoDescuento + this.exentoResumen : 0 + this.exentoResumen - this.montoDescuento;
		}

		if (this.totalRebajaAvaluo > 0) {
			let netoRebajado = this.netoAfectoResumen - this.totalRebajaAvaluo;
			if (netoRebajado < 0) netoRebajado = 0;
			const ivaRebajado = this.porcentajeIva * netoRebajado;
			this.montoIva = ivaRebajado;
			this.subTotalResumen = this.netoAfectoResumen + ivaRebajado;

		}

		this.montoTotalImpuestosEspecificos = this.getSpecificTaxesTotalFromItemListExcluded();
	}
	getTotalMainTaxComisionItemsExcluded() {
		this.netoAfectoResumenComision = this.listaComisionResumir.reduce((sum, item) => (item.neto != 0 ? sum + item.total : sum + 0), 0);
		if (this.opciones.tipoMoneda == "CLP") {
			this.montoDescuentoComision = +this.totalesDteFormGroup.controls.descuentoGlobal.value;
		}
		this.montoIvaComision = Math.round(this.porcentajeIva * (this.netoAfectoResumenComision - this.montoDescuentoComision));
		this.subTotalResumenComision = this.netoAfectoResumenComision - this.montoDescuentoComision;
		this.montoTotalImpuestosEspecificosComision = 0;
	}

	getNetoTotal(detalles: DetalleDte[], considerExempt: boolean = false) {
		let netoTotal = 0;
		detalles.forEach((detalle) => {
			if (!detalle.esExento || considerExempt) {
				netoTotal += detalle.total;
			}
		});
		return netoTotal;
	}

	getTotalExportItems() {
		this.exentoResumen = this.listaResumir.reduce((sum, item) => sum + item.total, 0);
	}

	ngOnDestroy() {
		this.subscriptions.forEach((sub) => {
			sub.unsubscribe();
		});
	}

	setTotalsForClausulaVenta() {
		let modalidadVentaSelected: ModalidadVentas = this.totalesDteFormGroup.controls.modalidadVenta.value;
		this.totalesDteEmitido.modalidadVentaId = modalidadVentaSelected ? modalidadVentaSelected.modalidadVentaId : undefined;
		this.totalesDteEmitido.modalidadVentaNombre = modalidadVentaSelected ? modalidadVentaSelected.sigla : undefined;
		this.totalesDteEmitido.codigoModalidadVenta = modalidadVentaSelected ? modalidadVentaSelected.codigoSii : undefined;
		let clausulaVentaSelected: ClausulaVentas = this.totalesDteFormGroup.controls.clausulaVenta.value;
		this.totalesDteEmitido.clausulaVenta = clausulaVentaSelected ? clausulaVentaSelected.clausulaVentaId : undefined;
		this.totalesDteEmitido.clausulaVentaObj = clausulaVentaSelected ? clausulaVentaSelected : undefined;
		this.totalesDteEmitido.clausulaVentaId = clausulaVentaSelected ? clausulaVentaSelected.clausulaVentaId : undefined;
		this.totalesDteEmitido.clausulaVentaGlosa = clausulaVentaSelected ? clausulaVentaSelected.sigla : undefined;
		this.totalesDteEmitido.codigoClausulaVenta = clausulaVentaSelected ? clausulaVentaSelected.codigoSii : undefined;
		this.totalesDteEmitido.calcularClausulaVenta(this.trasporteExportacion, this.opciones, this.otraMonedaResumen);
		this.totalClausulaVenta = this.totalesDteEmitido.montoClausulaVenta;
		this.fleteResumen = this.trasporteExportacion ? this.trasporteExportacion.flete : 0;
		this.seguroResumen = this.trasporteExportacion ? this.trasporteExportacion.seguro : 0;
		this.ref.detectChanges();
	}
	changeHaveIvaTerceros($event) {
		this.totalesDteFormGroup.controls.ivaTerceros.patchValue(Math.round(this.montoIva));
		this.totalesDteFormGroup.controls.ivaPropio.patchValue(0);
		this.showInputIvaTerceros = $event.target.checked;
		if (this.showInputIvaTerceros) {
			this.totalesDteFormGroup.controls.ivaTerceros.enable();
			this.totalesDteFormGroup.controls.ivaTerceros.setValidators([PositiveNumberValidator]);
		} else {
			this.totalesDteFormGroup.controls.ivaTerceros.disable();
		}
	}
	calculateIvaPropio() {
		var ivaTercero = Number.parseInt(this.totalesDteFormGroup.controls.ivaTerceros.value);
		var ivaTotal = Math.round(this.montoIva);
		var ivaTerceroString = this.currencyPipe.transform(ivaTercero, null, "$ ", "0.0-2", "es");
		var ivaTotalString = this.currencyPipe.transform(ivaTotal, null, "$ ", "0.0-2", "es");
		if (ivaTercero > ivaTotal) {
			this.currentSwal.icon = "info";
			this.currentSwal.title = "Iva de Terceros Erroneo";
			this.currentSwal.text = "El iva de terceros " + ivaTerceroString + " no puede ser mayor al iva total " + ivaTotalString;
			this.currentSwal.fire();
			this.totalesDteFormGroup.controls.ivaTerceros.patchValue(Math.round(this.montoIva));
			this.totalesDteFormGroup.controls.ivaPropio.patchValue(0);
			return;
		}
		this.totalesDteFormGroup.controls.ivaPropio.patchValue(Math.round(this.montoIva - ivaTercero));
		this.onSubmit();
	}

	resetTotals() {
		this.netoAfectoResumen = 0;
		this.exentoResumen = 0;
		this.subTotalResumen = 0;
		this.montoIva = 0;
		this.montoTotalImpuestosEspecificos = 0;
		this.totalResumen = 0;
	}

	checkTaxesIntegrity() {
		if (this.currentInvoiceType != InvoiceType.Boleta && this.listaResumir.some((item) => item.relatedProduct && item.relatedProduct.impuestos && item.relatedProduct.impuestos.length > 0)) {
			this.listaResumir.forEach((item) => {
				if (!item.impuestosAdicionales || item.impuestosAdicionales.length == 0) {
					if (item.relatedProduct && Array.isArray(item.relatedProduct.impuestos)) {
						let detalleDteImpuestoAdicionalList: DetalleDteImpuestoAdicional[] = [];
						let impuestoFromProduct = [...item.relatedProduct.impuestos];
						impuestoFromProduct = [...impuestoFromProduct];
						detalleDteImpuestoAdicionalList = item.relatedProduct.impuestos.map((i) => {
							let impuestoAdicional = new DetalleDteImpuestoAdicional();
							impuestoAdicional.codigoSii = i.tipoImpuesto;
							impuestoAdicional.nombreImp = i.nombre;
							if (this.opciones.sonDetallesConIVA) {
								impuestoAdicional.valor = Math.round((i.valor / 100) * (item.total / (1.19 + i.valor / 100)));
							} else {
								impuestoAdicional.valor = Math.round((i.valor / 100) * item.total);
							}
							impuestoAdicional.nroImp = item.relatedProduct.impuestos.indexOf(i) + 1;
							impuestoAdicional.tasa = i.valor;
							impuestoAdicional.impuestoIdRelated = i.impuestoId;
							return impuestoAdicional;
						});
						item.impuestosAdicionales = [...detalleDteImpuestoAdicionalList];
						item.impuestosAdicionales = [...item.impuestosAdicionales];
					}
				}
			});
		}
	}

	approximateTotalForTaxIncludedItems() {
		//VERIFICA EL CUADRE DEL TOTAL PARA ITEMS CON IVA INCLUIDO
		//CONSIDERA LA APROXIMACION de MONTOS DE IVA O NETO PARA CALZAR EL TOTAL
		let neto = Math.round(this.netoAfectoResumen);
		let subTotal = Math.round(this.subTotalResumen);
		let iva = Math.round(this.montoIva);
		if (this.currentInvoiceType == InvoiceType.Boleta) {
			//let subTotal = Math.round(this.subTotalResumen>0?this.subTotalResumen:this.brutoAfectoResumen-this.montoDescuento);
			if (this.montoDescuento == 0 && subTotal > 0) {
				if (subTotal + iva != this.brutoAfectoResumen && this.exentoResumen == 0) {
					iva = this.brutoAfectoResumen - subTotal;
				}
			}
		} else {
			if (this.montoDescuento == 0) {
				if (subTotal + iva != this.brutoAfectoResumen && this.exentoResumen == 0) {
					iva = this.brutoAfectoResumen - subTotal;
				}
			}
		}

		this.netoAfectoResumen = neto;
		this.montoIva = iva;
	}
}
